import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ListFieldPathContext = createContext(null);

export function ListFieldPathProvider({ children, basePath }) {
  return <ListFieldPathContext.Provider value={basePath}>{children}</ListFieldPathContext.Provider>;
}

ListFieldPathProvider.propTypes = {
  children: PropTypes.node,
  basePath: PropTypes.string.isRequired,
};

/**
 * 返回当前 List 循环项的 basePath，例如 "productList.0"。
 * 在 List 外部时返回 null。
 * 支持嵌套 List：外层 "orderList.0"，内层 "orderList.0.items.1"。
 */
export function useListFieldPath() {
  return useContext(ListFieldPathContext);
}
